module.exports = __webpack_public_path__ + "static/media/topic-img1.0b53507e.png";